import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'DataTable Example',
    href: '/datatable-example',
  },
  {
    title: 'Employee',
    isLink: false,
    prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
  },
];

const Title: PageTitle = {
  title: 'Employee',
  prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };
